import EkgRecording from './EkgRecording';

export default EkgRecording;



// WEBPACK FOOTER //
// ./src/views/components/EkgRecording/index.js